import { Route, Routes } from 'react-router-dom';
import { MapApiProvider } from '~/components/Map/Map';
import { EarnInStore } from '~/pages/rewards/EarnInStore/EarnInStore';
import EarnOnline from '~/pages/rewards/Online/Online';

import EarnLayout from '../Layouts/Earn.layout';

const RewardsRoutes = () => {
  return (
    <MapApiProvider>
      <Routes>
        <Route element={<EarnLayout />}>
          <Route path="dining" element={<EarnInStore />} />
          <Route path="online" element={<EarnOnline />} />
          <Route index element={<EarnInStore />} />
        </Route>
      </Routes>
    </MapApiProvider>
  );
};

export { RewardsRoutes };
